/** Zoom in/out button pair for charts. `zoom` is a divisor: 1 = full
 * range, 2 = half, … doubling per click up to `max`. The chart decides
 * what "half" means (latest half for time series, centered window for a
 * payoff grid). */

import type { ReactElement } from "react";

export function ZoomButtons({
  zoom,
  max = 8,
  onChange,
}: Readonly<{ zoom: number; max?: number; onChange: (zoom: number) => void }>): ReactElement {
  return (
    <div className="flex rounded-ctl border border-line bg-surface-1 p-0.5">
      <ZoomButton
        icon="ti-zoom-out"
        label="Zoom out"
        disabled={zoom <= 1}
        onClick={() => {
          onChange(Math.max(zoom / 2, 1));
        }}
      />
      <ZoomButton
        icon="ti-zoom-in"
        label="Zoom in"
        disabled={zoom >= max}
        onClick={() => {
          onChange(Math.min(zoom * 2, max));
        }}
      />
    </div>
  );
}

function ZoomButton({
  icon,
  label,
  disabled,
  onClick,
}: Readonly<{
  icon: string;
  label: string;
  disabled: boolean;
  onClick: () => void;
}>): ReactElement {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      className="rounded-ctl px-2 py-1 text-xs text-ink-secondary transition-colors hover:text-ink disabled:opacity-40"
      onClick={onClick}
    >
      <i className={`ti ${icon}`} />
    </button>
  );
}
